import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar, { AdminTopbar } from "@/components/AdminSidebar";

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen flex bg-gray-50">
      <AdminSidebar open={open} onClose={() => setOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <AdminTopbar onMenu={() => setOpen(true)} />
        <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6 lg:py-8 max-w-[1400px] w-full mx-auto" data-testid="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
